import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Breadcrumb from "../components/Reusable/Breadcrumb";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import { fetchUserInfo } from "../actions/security";
import { useTranslation } from "react-i18next";

const Faq = () => {
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);
  const loggedUserReducer = useSelector((state) => state.loggedUserReducer);

  const { t } = useTranslation();

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    dispatch(fetchUserInfo());
  }, []);

  const days =
    loggedUserReducer?.loggedUser?.countryId ==
    "8ab0a601-8805-4dc4-a5e1-58f383d83bf4"
      ? "60-90"
      : "30";

  return (
    <div className="faq-main-container">
      <Breadcrumb title={t("faq")} returnPage="/informations" />

      <div className="faq-list-container">
        <div>
          {[...Array(27)].map((_, index) => {
            const panelKey = `panel${index}`;
            const titleKey = `faqList.faq${index + 1}_title`;
            const descKey = `faqList.faq${index + 1}_desc`;

            const title = t(titleKey);
            const desc = t(descKey, { days });

            // ✅ Ako prevod ne postoji (vrati sam ključ), preskoči render
            if (!title || title === titleKey) return null;

            return (
              <Accordion
                key={panelKey}
                expanded={expanded === panelKey}
                onChange={handleChange(panelKey)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`${panelKey}-content`}
                  id={`${panelKey}-header`}
                >
                  <Typography component="span">{title}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>{desc}</Typography>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Faq;
